module.exports = __webpack_public_path__ + "static/media/Captain Marvel 1.ca8e8dfd.jpg";